package com.timacookies

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.MutablePalette
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

class SitePalette(
  val font: Color,
  val background: Background,
) {

  class Background(
    val primary: Color,
    val secondary: Color,
  )
}

object SitePalettes {
  val light = SitePalette(
    font = Color.rgb(0x49321D),
    background = SitePalette.Background(
      primary = Color.rgb(0xF2EEE8),
      secondary = Color.rgb(0xE7DDD3),
    ),
  )
  val dark = SitePalette(
    font = Color.rgb(0xD8B99D),
    background = SitePalette.Background(
      primary = Color.rgb(0x121212),
      secondary = Color.rgb(0x1A1A1A),
    ),
  )
}

fun ColorMode.toSitePalette(): SitePalette =
  when (this) {
    ColorMode.LIGHT -> SitePalettes.light
    ColorMode.DARK -> SitePalettes.dark
  }

@InitSilk
fun initTheme(ctx: InitSilkContext) {
  ctx.theme.palettes.light
    .initColors(SitePalettes.light)

  ctx.theme.palettes.dark
    .initColors(SitePalettes.dark)
}

private fun MutablePalette.initColors(sitePalette: SitePalette) {
  color = sitePalette.font
  background = sitePalette.background.primary
}
